import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.22 14.715a1.3 1.3 0 0 1-.355-.455 1.3 1.3 0 0 1-.127-.563V8.24c0-1.16-.949-2.105-2.115-2.105H9.254a.435.435 0 0 1-.437-.464l.251-3.797A1.403 1.403 0 0 0 7.666.381a1.404 1.404 0 0 0-1.403 1.493l.25 3.797a.435.435 0 0 1-.437.464H4.709A2.113 2.113 0 0 0 2.593 8.24v6.042c0 .737.603 1.337 1.344 1.337h8.957c.22 0 .41-.133.483-.34a.505.505 0 0 0-.157-.564M3.202 8.24c0-.824.676-1.495 1.506-1.495h1.369A1.046 1.046 0 0 0 7.122 5.63L6.87 1.833q-.002-.026-.001-.052c0-.436.357-.79.796-.79.223 0 .43.089.582.252a.78.78 0 0 1 .212.59l-.251 3.798a1.047 1.047 0 0 0 1.045 1.114h1.369c.83 0 1.505.67 1.505 1.495v.443H3.202zm.734 6.77a.73.73 0 0 1-.734-.727v-4.99h8.927v4.404a1.916 1.916 0 0 0 .517 1.313z"
    }, null, -1)
  ]))]))
}
export default { render: render }